const liveSearchFacetsMapping = {
    /**
     * Map facets and merge BH size facets
     *
     * @param {Array} facets - The array of facets to map.
     * @returns {Array} - The mapped array of facets.
     */
    mapFacets(facets) {
        return facets.reduce((mappedFacets, facet) => {
            const mappedFacet = this.shouldMapFacet(facet)
                ? this.createMappedFacet(facet)
                : this.shouldCreateBhSizeFacet?.(facet)
                    ? this.createBhSizeFacet?.(facet)
                    : null

        if (mappedFacet) {
            mappedFacets.push(mappedFacet)
        }
            return mappedFacets
        }, [])
    },

    /**
     * Check if a facet should be mapped
     *
     * @param {Object} facet - The facet to check.
     * @returns {boolean} - True if the facet should be mapped, false otherwise.
     */
    shouldMapFacet({ buckets, attribute }) {
        const mergedBhAttribute = this?.facetConfig?.mergedBhAttribute
        const removedAttributes = this?.facetConfig?.removedAttributes ?? []
        return (Array.isArray(buckets) && buckets.length > 0) &&
            attribute !== mergedBhAttribute &&
            !removedAttributes.includes(attribute)
    },

    /**
     * Create mapped facet
     *
     * @param {Object} facet - The facet to map.
     * @returns {Object} - The mapped facet object.
     */
    createMappedFacet({ title, attribute, buckets }) {
        const singleButtonAttributes = this?.facetConfig?.singleButtonAttributes ?? []
        const isSingleButton = singleButtonAttributes.includes(attribute)
        const options = (Array.isArray(buckets) ? buckets : []).map(({ title }) => ({
            label: title,
            id: String(title ?? '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
        }))

        return { name: title, attribute, isSingleButton, options }
    }
}

export default liveSearchFacetsMapping
